import { put } from 'redux-saga/effects'

import Account from 'common/modules/account'
import { focusPrompt } from './frameUtilities'
import Internal from '../../internal'

export default function* watchFrameSubmit({ email }) {
    yield put(Internal.creators.sendMessage({
        payload: {
            target: 'pico_prompt',
            ...Account.creators.signupConfirmationEmail({
                payload: {
                    email,
                },
            }),
        },
    }))

    yield focusPrompt('/registration')
}
